import { ko } from 'date-fns/locale/ko';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { registerLocale } from 'react-datepicker';
import { Link, useSearchParams } from 'react-router-dom';
import { deletePAJAC060, postPAJAD010, putPAJAC060 } from '../../../services/Api';
import CandidateList from '../../../shared/components/CandidateList';
import Pagination from '../../../shared/components/Pagination';
import PopupSendMail from '../../../shared/components/PopupSendMail';
import SearchDateRange from '../../../shared/components/SearchDateRange';
import SideNav from '../../../shared/components/SideNav';
import { MESSAGE } from '../../../shared/constants/app';
import { handleFocus } from '../../../utils';
registerLocale('ko', ko);

const PAJAD010 = () => {
    const [pages, setPages] = useState({});
    const [data, setData] = useState({});
    const [dataCountTab, setDataCountTab] = useState({});
    const [dataStatistic, setDataStatistic] = useState({});
    const [searchParams, setSearchParams] = useSearchParams();
    const page = Number(searchParams.get('page')) || 1;
    const [resultOption, setResultOption] = useState('');
    const [refreshData, setRefreshData] = useState(false);
    const [popupSendMailOpen, setPopupSendMailOpen] = useState(false);
    const [receiver, setReceiver] = useState({ id: '', name: '' });
    const [payload, setPayload] = useState({});

    const [itemFilter, setItemFilter] = useState([
        { label: '전체', key: 'total', value: '', active: 1 },
        { label: '합격', key: 'pass', value: 'P', active: 0 },
        { label: '불합격', key: 'fail', value: 'F', active: 0 },
        { label: '결과대기', key: 'waiting', value: 'W', active: 0 },
    ]);

    const closePopup = () => {
        setPopupSendMailOpen(false);
    };

    const handleChangeResultOption = (e) => {
        const dataValue = e.currentTarget.dataset.value;

        setItemFilter((prevFilters) =>
            prevFilters.map((item) => ({
                ...item,
                active: item.value === dataValue ? 1 : 0,
            })),
        );

        if (resultOption !== dataValue) {
            setResultOption(dataValue);
            setSearchParams(1);
        }
    };

    const validateResult = (seq, statusMessage = '지원 결과를 선택해 주세요.') => {
        const { result, reason, reasonType } = payload[seq] || {};
        if (!result || result === 'W') {
            window.alert(statusMessage);
            handleFocus(`status-${seq}`);
            return false;
        }
        if (result === 'F' && !reasonType) {
            window.alert('불합격 사유를 선택해 주세요.');
            handleFocus(`reason-type-${seq}`);
            return false;
        }
        if (result === 'F' && reasonType === '직접입력' && !reason) {
            window.alert('불합격 사유를 입력해 주세요.');
            handleFocus(`reason-${seq}`);
            return false;
        }
        return true;
    };

    const handleDelete = async (item) => {
        const seq = item?.seq;

        const isWaiting = item?.resCancel === 'N' && item?.result === 'W';
        if (isWaiting && !validateResult(seq, '합격/불합격 여부를 선택 후 삭제 가능합니다')) return;

        const confirmDelete = window.confirm('삭제하시겠습니까?');
        if (!confirmDelete) return;

        if (isWaiting) {
            const saved = await handleSave(item, { silent: true });
            if (!saved) return;
        }

        deletePAJAC060(seq)
            .then(() => {
                window.alert(MESSAGE.notify.updateSuccess);
                setRefreshData((prev) => !prev);
            })
            .catch((error) => {
                console.log(error);
                window.alert(MESSAGE.notify.updateError);
            });
    };


    useEffect(() => {
        const initialStates = {};
        if (Array.isArray(data)) {
            data.forEach((item) => {
                initialStates[item.seq] = {
                    result: item.result || 'W',
                    reasonType: '',
                    reason: item.reason || '',
                };
            });
        }
        setPayload(initialStates);
    }, [data]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const seq = name.split('-')[1];
        setPayload((prev) => ({
            ...prev,
            [seq]: { ...prev[seq], reason: value },
        }));
    };

    const handleChangeDropdown = (selectedValue, name) => {
        const parts = name.split('-');
        const seq = parts[parts.length - 1];
        const type = parts.length === 3 ? 'reason-type' : parts[0];

        setPayload((prev) => {
            const newState = { ...prev[seq] } || {};
            if (type === 'status') {
                newState.result = selectedValue;
                if (selectedValue !== 'F') {
                    newState.reasonType = '';
                    newState.reason = '';
                }
            } else if (type === 'reason-type') {
                newState.reasonType = selectedValue;
                newState.reason = selectedValue !== '직접입력' ? selectedValue : '';
            }
            return { ...prev, [seq]: newState };
        });
    };

    const handleSearchDateRange = (startDate, endDate) => {
        getListData(startDate, endDate);
    };

    const getListData = (startDate, endDate) => {
        const startDateFormat = startDate ? moment(startDate).format('YYYY-MM-DD') : null;
        const endDateFormat = endDate ? moment(endDate).format('YYYY-MM-DD') : null;
        postPAJAD010({
            page,
            startDate: startDateFormat,
            endDate: endDateFormat,
            options: { ...(resultOption ? { result: [resultOption] } : {}) },
        })
            .then(({ data }) => {
                setPages(data.info);
                setData(data.data.list);
                setDataCountTab(data.data.countByTab);
                setDataStatistic(data.data.statistic);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const handleSave = async (item, { silent = false } = {}) => {
        const seq = item.seq;
        const { result, reason } = payload[seq] || {};
        const confirm =
            result === 'P'
                ? '지원자에게 합격 통보를 하시겠습니까?'
                : result === 'F'
                    ? '전형 결과를 확정하시겠습니까? 확정 이후에는 수정이 불가능합니다.'
                    : '';

        const updatedPayload = { seq, result, reason };
        if (!validateResult(seq)) return false;
        if (!silent && !window.confirm(confirm)) return false;
        try {
            await putPAJAC060(updatedPayload);
            if (!silent) {
                getListData();
                window.alert(MESSAGE.notify.updateSuccess);
            }
            return true;
        } catch (error) {
            console.log(error);
            return false;
        }
    };

    useEffect(() => {
        getListData();
        // eslint-disable-next-line
    }, [page, resultOption, refreshData]);
    return (
        <>
            <div id="content" className="sub-page">
                <div className="container">
                    <div id="top-sub-page">
                        <SideNav />
                        <div className="resume">
                            <div className="resume__inner">
                                <h3 className="resume__tit">지원자 관리 <span style={{ float: 'right', marginTop: '20px' }}>※ 현재 진행중인 공고 기준</span></h3>

                                <div className="rsm-stt">
                                    <ul className="rsm-stt__list">
                                        <li className="rsm-stt__item">
                                            <span>총 지원자 수</span>
                                            <div className="rsm-stt__num">{dataStatistic?.total}</div>
                                        </li>
                                        <li className="rsm-stt__item">
                                            <span>이력서 미열람</span>
                                            <div className="rsm-stt__num">{dataStatistic?.unread}</div>
                                        </li>
                                        <li className="rsm-stt__item">
                                            <span>이력서 열람</span>
                                            <div className="rsm-stt__num">{dataStatistic?.isRead}</div>
                                        </li>
                                        <li className="rsm-stt__item">
                                            <span>결과 확정</span>
                                            <div className="rsm-stt__num">{dataStatistic?.processed}</div>
                                        </li>
                                    </ul>
                                    <SearchDateRange
                                        handleSearchDateRange={handleSearchDateRange}
                                        setSearchParams={setSearchParams}
                                    />
                                    <div className="mtch__block mtch__block--rp4">
                                        {itemFilter.map((item, index) => (
                                            <Link
                                                className={`mtch__cnd ${item.active ? 'active' : ''}`}
                                                onClick={handleChangeResultOption}
                                                key={index}
                                                data-value={item.value}
                                            >
                                                {`${item.label}`}({dataCountTab?.[item.key]})
                                            </Link>
                                        ))}
                                    </div>
                                    <ul className="dntInf__grid dntInf__head dntInf__candidate__head pajad010">
                                        <li style={{ padding: 0 }}>내용</li>
                                        <li style={{ padding: 0 }}>날짜</li>
                                        <li style={{ padding: 0 }}>전형결과/사유</li>
                                        <li style={{ padding: 0 }}>관리</li>
                                    </ul>
                                    <CandidateList
                                        data={data}
                                        handleChangeDropdown={handleChangeDropdown}
                                        handleInputChange={handleInputChange}
                                        handleDelete={handleDelete}
                                        refreshData={getListData}
                                        setPopupSendMailOpen={setPopupSendMailOpen}
                                        setReceiver={setReceiver}
                                        getListData={getListData}
                                        payload={payload}
                                        handleSave={handleSave}
                                    />
                                    <Pagination pages={pages} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {popupSendMailOpen && <PopupSendMail closePopup={closePopup} receiver={receiver} />}
        </>
    );
};

export default PAJAD010;
